var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vue-archive" }, [
    _c(
      "div",
      { class: _vm.parentClass },
      [
        _vm.isLoading ? _c("div", [_vm._m(0)]) : _vm._e(),
        _vm._v(" "),
        !_vm.hasResults
          ? _c("div", { staticClass: "row justify-content-center mb-5" }, [
              _vm._m(1)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.posts.data, function(post, index) {
          return _c(
            "div",
            {
              key: post.id,
              staticClass: "row align-items-center p-5 vue-archive-item"
            },
            [
              _c(
                "div",
                {
                  class: {
                    "col-md-7 order-last order-md-last":
                      (index - (_vm.page - 1) * _vm.limit) % 2 == 0,
                    "col-md-7 order-last order-md-first":
                      (index - (_vm.page - 1) * _vm.limit) % 2 != 0
                  }
                },
                [
                  _c("p", [_c("strong", [_vm._v(_vm._s(post.title))])]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(post.post.excerpt))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "row justify-content-center justify-content-md-end align-items-center":
                          (index - (_vm.page - 1) * _vm.limit) % 2 == 0,
                        "row justify-content-center justify-content-md-start align-items-center":
                          (index - (_vm.page - 1) * _vm.limit) % 2 != 0
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          class: {
                            "col-auto order-last order-md-last":
                              (index - (_vm.page - 1) * _vm.limit) % 2 == 0,
                            "col-auto order-last order-md-first":
                              (index - (_vm.page - 1) * _vm.limit) % 2 != 0
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-read-more",
                              attrs: { href: _vm.makeItemLink(post) }
                            },
                            [_vm._v("Read More")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("component-social")
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-5 order-first" }, [
                _c(
                  "div",
                  { staticClass: "embed-responsive embed-responsive-16by9" },
                  [
                    _c("a", { attrs: { href: _vm.makeItemLink(post) } }, [
                      _c("img", {
                        staticClass: "embed-responsive-item",
                        attrs: {
                          src: post.featured_image
                            ? post.featured_image
                            : "/uploads/images/web/history.png",
                          alt: post.title
                        }
                      })
                    ])
                  ]
                )
              ])
            ]
          )
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "row py-5 justify-content-center border-top border-primary"
          },
          [
            _c(
              "pagination",
              {
                staticClass: "col-auto vue-pagination",
                attrs: { limit: _vm.limit, data: _vm.posts },
                on: { "pagination-change-page": _vm.getResults }
              },
              [
                _c("li", { attrs: { slot: "prev-nav" }, slot: "prev-nav" }, [
                  _vm._v("<")
                ]),
                _vm._v(" "),
                _c("li", { attrs: { slot: "next-nav" }, slot: "next-nav" }, [
                  _vm._v(">")
                ])
              ]
            )
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto p-5 my-3 text-center border" }, [
      _c("h2", { staticClass: "text-muted" }, [_vm._v("Loading")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto p-5 my-3 text-center border" }, [
      _c("h2", { staticClass: "text-muted" }, [_vm._v("No Matching Results")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Sorry! We haven't been able to find any results for your search."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }